import * as React from "react";
import { useLocation } from "react-router-dom";
import { Image } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import { Hearts } from 'react-loading-icons';
import { Helmet } from 'react-helmet';

import { motion } from "framer-motion";
const nl2br = require('react-nl2br');

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const View = () => {
    window.scrollTo(0, 0);
    let query = useQuery();

    const [giftId, setGiftId] = React.useState(query.get('giftId'));
    const [ittengo, setIttengo] = React.useState([]);
    const [message, setMessage] = React.useState([]);
    const [expiredAt, setExpiredAt] = React.useState([]);
    const [isError, setIsError] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
  
    const fetchData = () => {
      fetch("https://" + process.env.REACT_APP_API_HOST + "/api/v1/gift/gift/" +giftId+ "/", {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        }
      })
      .then(res => res.json())
      .then(
        (result) => {
          setIsLoading(false);
          setIttengo(result.ittengo);
          setMessage(result.message);
          setExpiredAt(result.expired_at);
        })
      .catch(
        (error) => {
          setIsLoading(false);
          setIsError(true);
          console.log(error);
        }
      )
    };
    React.useEffect(() => {
      fetchData();
    }, [])
  
    if (isLoading) {
      return <main className="d-flex vh-100"><Hearts className="m-auto" stroke="#FBC1B8" fill="#FBC1B8" height="8em" /></main>
    }
    if (isError) {
      return <main className="d-flex vh-100">エラー</main>
    }
    return (
      <>
        <Helmet>
            <title>【母の日】メッセージカードか届いています。</title>
            <meta name="description" content=""/>
        </Helmet>
        <motion.div
          animate={{
            x: 0,
            opacity: 1
          }}
          initial={{
            x: 100,
            opacity: 0
          }}
          exit={{
            x: -100,
            opacity: 0
          }}
          transition={{
            duration: 0.2
          }}
        >
          <main>
            <Image src={ittengo.image} alt={ittengo.honkaku.title} fluid />
            <div className="mt-4">
              <Image src={ittengo.border_top} className="mb-3" fluid />
              <p>{nl2br(message)}</p>
              <Image src={ittengo.border_bottom} fluid />
            </div>

            <div className="text-center my-5">
                ・<br />
                ・<br />
                ・<br />
            </div>

            <div>
                <p><small className="text-secondary">※このカードは {expiredAt} まで閲覧できます。</small><br />
                <a href="https://elform.co/g/itmw/mothersday2022/" target="_blank" rel="noreferrer"><small className="text-secondary">ご意見・ご感想はこちら</small></a></p>
            </div>
          </main>
        </motion.div>
      </>
    );
}